import Dexie, { Table } from "dexie";
import * as Api from "../api";

export type DBEntity = {
  createdAtMS?: number;
};

export type ContentEntityType = DBEntity &
  Api.Server.ContentEntityTypeLookUpSlimVersionOutput;

export type AllowedContentEntities = DBEntity & { id: string };

export type ContentComponent = DBEntity &
  Api.Server.ComponentWithUniqueIdOutput;
export type ContentPage = DBEntity &
  Api.Server.CollectionComponentDetailsOutput;
export type ContentEntity = DBEntity & Api.Server.ContentEntityOutput;

export type ContentEntityProgress = DBEntity &
  Api.Server.ContentEntityProgressOutput;

export type UIEntities = DBEntity & {
  uniqueId: string;
  contentIds: string[];
  // status: ThunkStatus;
  // moreStatus: ThunkStatus;
  pageNumber: number;
  pageSize: number;
  hasNextPage: boolean;
  totalCount: number;
};

export type ReaderFlow = DBEntity & {
  userId: string;
} & Api.Server.FlowOutput2;

export type ReaderPlanItem = Api.Server.CustomerPlanOutput;

export type ReaderPlan = DBEntity & {
  userId: string;
  plans: ReaderPlanItem[];
};

export class ContentDB extends Dexie {
  entityTypes!: Table<ContentEntityType, number>;
  allowedEntities!: Table<AllowedContentEntities, number>;

  components!: Table<ContentComponent, string>;
  pages!: Table<ContentPage, string>;
  entities!: Table<ContentEntity, string>;

  progresses!: Table<ContentEntityProgress, string>;

  uiEntities!: Table<UIEntities, string>;

  readerFlows!: Table<ReaderFlow, string>;
  readerPlans!: Table<ReaderPlan, string>;

  constructor() {
    super("ContentDBV2");
    this.version(2).stores({
      entityTypes: "id, createdAtMS",
      allowedEntities: "id, createdAtMS",

      components: "id, createdAtMS",
      pages: "id, createdAtMS",
      entities: "id, createdAtMS",

      progresses: "contentEntityId, createdAtMS",

      uiEntities: "uniqueId, createdAtMS",

      readerFlows: "userId, createdAtMS",
      readerPlans: "userId, createdAtMS",
    });
  }
}

export const db = new ContentDB();

// db.on('populate', populate);

export function resetDatabase() {
  return db.transaction("rw", db.components, db.pages, async () => {
    await Promise.all(db.tables.map((table) => table.clear()));
    // await populate();
  });
}
